import styled from 'styled-components';

// Notation: This ContainerBaseModalComment is used in other components, be careful when changing it;
export const ContainerBaseModalComment = styled.div`
  padding: 1rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const TitleModal = styled.h4`
  font-weight: bold;
`;

